import { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { getOrgDataById, getUserDataById } from "../models/DataFunctions";

const ProtectedRoute = ({
  children,
  requiredRole,
  needs_org = true,
  navigateWorkspace,
}) => {
  const { currentUser, loading } = useAuth(); // Assuming this comes from Firebase auth context
  const [userData, setUserData] = useState(null); // State for user data
  const [orgData, setOrgData] = useState(null); // State for org data
  const [loadingUserData, setLoadingUserData] = useState(true); // State for loading user data
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user data from Firestore if currentUser exists
    const fetchUserData = async () => {
      if (currentUser) {
        try {
          const data = await getUserDataById(currentUser.uid);
          if (data === null) {
            navigate("/login");
          }
          if (data?.org_id) {
            const orgData = await getOrgDataById(data.org_id);
            setOrgData(orgData);
          }
          setUserData(data);
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        } finally {
          setLoadingUserData(false);
        }
      } else {
      }
    };

    fetchUserData();
  }, [currentUser]);

  // Show loading state while authentication or user data is being fetched
  if (loading) {
    return <div></div>;
  }

  // Redirect to login if the user is not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (loadingUserData) {
    return <div></div>;
  }

  if (!userData) {
    console.error("userData missing");
    return <Navigate to="/login" replace />;
  }

  if (needs_org) {
    if (!userData.org_id) {
      return <Navigate to="/setup" replace />;
    }
  }

  // Check if the user has the required role
  if (requiredRole) {
    if (requiredRole === "admin" && !userData.admin) {
      console.error("role not allowed" + userData.role);
      navigateWorkspace("/home");
    }
  }
  // Render the children if all checks pass

  return children;
};

export default ProtectedRoute;
